import { Injectable } from "@angular/core";
import { BaseModel } from "./base-model";
import { HttpService } from "../../services/http.service";
import { HttpResponse } from "@angular/common/http";

@Injectable()
export class LanguageJsonModelService extends BaseModel {
	private languageData: any;

	constructor(private httpService: HttpService) {
		super();
	}
	public initialize(data) {
		this.loadLanguageJSON(data);
	}
	private loadLanguageJSON(url) {
		this.httpService.get(url).then((res: HttpResponse<any>) => {
			this.languageData = res.body;
			this._notifier.next("data");
		});
	}

	public get allLanguages(): Array<string> {
		return this.languageData;
	}
}
